"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCustomFields = void 0;
const _1 = require(".");
const getBoolean = (maybeBoolean, defaultBoolean = false) => {
    if (typeof maybeBoolean === "boolean") {
        return maybeBoolean;
    }
    return defaultBoolean;
};
const generateCustomFields = (questions, overrides) => {
    let updatedQuestions = { en: {} };
    for (const lang in { ..._1.Languages, en: "" }) {
        const customQuestions = [];
        for (const [questionId, value] of Object.entries(questions)) {
            let langValues = value.en;
            if (lang in value) {
                const val = value[lang];
                if (val)
                    langValues = val;
            }
            customQuestions.push({
                id: value.id ||
                    value.internalLabel
                        .toLowerCase()
                        .replace(/ +/g, "-")
                        .replace(/[^a-z0-9\-]/g, ""),
                type: value.type,
                required: getBoolean(overrides === null || overrides === void 0 ? void 0 : overrides[questionId].required, value.defaultRequired),
                defaultSortOrder: value.defaultSortOrder,
                ...langValues,
            });
        }
        customQuestions.sort((a, b) => a.defaultSortOrder - b.defaultSortOrder);
        updatedQuestions = {
            ...updatedQuestions,
            [lang]: { customFields: customQuestions },
        };
    }
    return updatedQuestions;
};
exports.generateCustomFields = generateCustomFields;
//# sourceMappingURL=generateCustomFields.js.map